export default "__VITE_ASSET__CNXEwLEs__"